import type { Phrases } from '../common/Phrases.d';

import React, { useState } from 'react';
import { Button } from '../../../components/Button';
import { Modal, ModalActionButtons } from '@hdir/ui/modal';
import { useFormContext } from '/react4xp/components/react-hook-form/FormContext';

export function CancelDialog({
	phrases,
	href,
}: {
	phrases: Phrases;
	href: string;
}): JSX.Element {
	const { formState: { isDirty } } = useFormContext();
	const [open, setOpen] = useState(false);
	return (
		<>
			<Button
				variant='secondary'
				onClick={() => {
					if (isDirty) {
						setOpen(true);
					} else {
						window.location.href = href;
					}
				}}
			>
				{phrases['notificationForm.term.cancel']}
			</Button>

			<Modal
				className='min-h-[300px]'
				isOpen={open}
				onCloseClick={() => setOpen(false)}
				title={phrases['notificationForm.common.cancelDialog.heading']}
			>
				{/* Margin doesn't collapse so using md rather than xl */}
				<p className='mt-md'>
					{phrases['notificationForm.common.cancelDialog.ingress']}
				</p>
				<ModalActionButtons>
					<Button variant="tertiary" onClick={() => setOpen(false)}>
						{phrases['notificationForm.common.cancelDialog.cancelButtonText']}
					</Button>
					<Button
						onClick={() => {
							window.location.href = href;
						}}
					>
						{phrases['notificationForm.common.cancelDialog.confirmButtonText']}
					</Button>
				</ModalActionButtons>
			</Modal>
		</>
	);
}
